import t from "./index27.js";
import { resolveComponent as n, openBlock as l, createElementBlock as a, createElementVNode as s, createVNode as o } from "vue";
import "./index28.js";
import c from "../../../../_virtual/index.js";
const r = { class: "navigation-skeleton" }, i = { class: "skeleton-left" }, m = { class: "skeleton-right" };
function _(d, p, f, k, h, v) {
  const e = n("Shimmer");
  return l(), a("div", r, [
    s("div", i, [
      o(e, { class: "skeleton-inner logo" })
    ]),
    s("div", m, [
      o(e, { class: "skeleton-inner small" }),
      o(e, { class: "skeleton-inner small" }),
      o(e, { class: "skeleton-inner small last" })
    ])
  ]);
}
const N = /* @__PURE__ */ c(t, [["render", _], ["__scopeId", "data-v-dafa7c13"]]);
export {
  N as default
};
//# sourceMappingURL=index16.js.map
